var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.prompt)?_c('v-card-actions',[_c('a',{on:{"click":_vm.installer}},[_vm._v(_vm._s(_vm.$localize('Login.link.installApp')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }